import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import _ from 'lodash'
import { useAuth } from '../../hooks/useAuth';
const RewardPointsDetail = (props) => {
    const {getToken}=useAuth();
    const [userId, setUserId] = useState('');
    const [data, setData] = useState();
    const location = useLocation();
    const { state } = location;

    useEffect(() => {
        getRewardsDetail(state?.reward_id);
    }, []);

    const getRewardsDetail = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getRewardsDetials(token, id)
                .then((res) => {
                    if (res?.code === 200) {
                        setData(res.data);
                    }
                })
                .catch((err) => { });
        }
    };

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={3} className="text-center">
                    <Link
                        state={{
                            agency_id: state?.agency_id,
                            agency_details: state?.agency_details,
                            vendor_id: state?.vendor_id
                        }}
                        to={state?.redirect_url || '/reward-points'}
                    >
                        <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col sm={4}>
                    <div className="detail-heading ms-5">Rewards Details</div>
                </Col>
            </Row>
            {/* //show offer title, banner, short description, validity and points requirements */}
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3 ps-0 ms-0">
                    <Row>
                        <Col md={4}>
                            <div className="detail-small-heading">Logo</div>
                            <img src={data?.banner} alt="" width={150} />
                        </Col>
                        <Col md={4}>
                            <div className="detail-small-heading">Name</div>
                            <div className="detail-value">{data?.name}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-headingg">Number of Allow Redeems</div>
                            <div className="detail-value">{data?.noOfAllowRedeems}</div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col md={4}>
                            <div className="detail-small-heading">Redeemed Count</div>
                            <div className="detail-value">{data?.redeemedCount}</div>
                        </Col>
                        <Col md={4}>
                            <div className="detail-small-heading">Required Points</div>
                            <div className="detail-value">{data?.requiredPoints}</div>
                        </Col>

                        <Col md={4}>
                            <div className="detail-small-heading">Status</div>
                            <div className="detail-value">{_.capitalize(data?.status)}</div>
                        </Col>
                    </Row>

                    <Row className="mt-5">
                        <Col md={4}>
                            <div className="detail-small-heading">Validity</div>
                            <div className="detail-value">{data?.validity ? moment(data?.validity).format('MM-DD-YYYY') : ''}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default RewardPointsDetail;
